import { BaseWidgetRenderer } from './base-widget-renderer';
import { HeaderWidgetJsonData, WidgetRenderOptions } from '../../models/element-types';

export class HeaderWidgetRenderer extends BaseWidgetRenderer<HeaderWidgetJsonData> {
    protected override get defaultData(): HeaderWidgetJsonData {
        return {
            id: '',
            type: 'header',
            content: ''
        };
    }

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    protected renderContent(widgetJsonData: HeaderWidgetJsonData, options: WidgetRenderOptions): HTMLElement {
        const content = document.createElement('div');
        content.classList.add('element-content');

        const textElement = document.createElement('div');
        textElement.dataset['inlineInject'] = '';
        textElement.dataset['widget'] = 'header';
        textElement.classList.add('ck-content');

        if (widgetJsonData.content) {
            textElement.innerHTML = widgetJsonData.content;
        }

        content.appendChild(textElement);
        return content;
    }
}
